import React, { useState } from 'react';
import Box from "@material-ui/core/Box";
import { Button, Container, createStyles, Grid, makeStyles, Paper, TextField, Theme } from "@material-ui/core";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { useHistory } from "react-router-dom";
import { ICliente } from '../../entities/catalogos/ICliente';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { AttachFile, Delete, Height, Search } from '@material-ui/icons';
import useCommonApi from '../../api/useCommonApi';
import LoadingDialog from '../controls/LoadingDialog';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import swal from 'sweetalert2';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            height: '100%',
            backgroundColor: "#fff",
            margin: "0px",
            padding: "0 0 20px 0",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            paddingTop: "50px",
            minHeight: "220px"
        },
        tr: {
            fontWeight: 600
        },
        filters: {
            backgroundColor: "#ececec",
            boxShadow: "none",
            verticalAlign: "middle",
            padding: "10px"
        },
        label: {
            color: "#313131",
            fontSize: "16px",
            fontWeight: "bold",
            paddingTop: "10px",
            paddingLeft: "10px",
            fontFamily: 'Roboto'
        },
        textField: {
            backgroundColor: "#fff"
        },
        icon: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",
        },
        marginButton: {
            margin: "10px 0px 0 30px"
        }
    }),
);


interface StateProps {
    cliente: ICliente
}

interface DispatchProps {

}

interface OwnProps {
    setArchivos: (archivos: any) => void
    archivos: any
    disabled?: boolean
}


type Props = StateProps & DispatchProps & OwnProps

const CartaInstruccion = (props: Props) => {
    const disabled = props.disabled ?? false;
    const classes = useStyles();
    const history = useHistory();
    const [showLoading, setLoading] = useState(false);
    const apiSource = useCommonApi();
    const [descripcion, setDescripcion] = useState('');

    const [archivos, setArchivos] = useState<any[]>([]);

    const getBase64 = (file) => {
        return new Promise(resolve => {
            let fileInfo;
            let baseURL: any;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    }

   

    const handleUpload = (event) => {
        if (disabled) {
            return;
        }
        let file = event.target.files[0];

        getBase64(file).then(result => {
            if (result != null) {
                let newArr = [...archivos];
                let resultData: any = result;
                let base64String = resultData.split(',');
                let tipo = resultData.split(';');

                    if(file.name.length > 100){
                        let message=(traducirMessage(290).replace("####",file.name)).replace("#####",file.name.length); //"El archivo: #### tiene un total de ##### caracteres en su nombre, favor de elegir un archivo con menos de 100 caracteres como nombre.";
                        swal.fire({
                            titleText: traducirMessage(11), // '!Aviso!',
                            text: message,
                            type: 'warning'
                        });
                    }
                    else{
                        if (file.name) {
                            let extension=file.name.substring(file.name.lastIndexOf(".")+1)
                            if(extension==="pdf"||extension==="docx"||extension==="xlsx"||extension==="png"||extension==="gif"||extension==="jpg"||extension==="xls"||extension==="doc")
                            {
                                newArr.push({ 'nombre': file.name, 'file64': base64String[1], 'tipo': tipo[0] });
                                setArchivos(newArr);
                                props.setArchivos(newArr);
                            }
                            else {
                                swal.fire({titleText: '¡Aviso!', text: "Solo se permite anexar pdf, word, excel, gif, png y jpg", type: 'warning',});
                            }
        
                        }
                    }
            }

        });
    }


    const b64toBlob = (row, contentType = '') => {        
        const byteCharacters = atob(row.file64);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: row.tipo });
        let extension = row.tipo.indexOf("pdf") !== -1 ? "pdf" : "docx"

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${row.nombre}`;
        link.click();

        return blob;
    }

    const handleDownload = (row) => {
        b64toBlob(row);
    }

    const handleRemoveFile = (row) => {
         if (disabled) {
            return;
        }
        let newArr = [...archivos]
        newArr = newArr.filter(o => o.nombre !== row.nombre);
        setArchivos(newArr);
        props.setArchivos(newArr);
    }


    React.useEffect(() => {

        if(props.archivos){
            setArchivos(props.archivos);
        }

    });


    return (<>


        <Container maxWidth="xl" className={classes.filters} >

            <Grid container  >


                <Grid item xs={8}>
                    <Box mb={3} className={classes.label}>
                        {/* Favor de seleccionar el archivo que desea agregar */traducirMessage(111)}
            </Box>
                </Grid>
                <Grid item xs={2} className={classes.marginButton} >
                    <input
                        accept=".pdf,.doc,.docx"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        onChange={handleUpload}
                        disabled={props.disabled}
                        type="file"
                    />
                    <label htmlFor="raised-button-file">
                        <Button className={classes.icon} component="span" variant="contained" color="primary" disabled={props.disabled}>
                            <input
                                type="file"
                                hidden
                                disabled={props.disabled}
                            />
                            <AttachFile />
                        </Button>
                    </label>
                </Grid>
            </Grid>

        </Container>

        <Container maxWidth="xl" className={classes.table}>

            <TableContainer >
                <Table aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tr}>
                                {/* ARCHIVO */traducirLabel(303)}
                            </TableCell>
                            <TableCell className={classes.tr}></TableCell>
                            <TableCell className={classes.tr}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {archivos.map((row, i) => (
                            <TableRow key={i}>
                                <TableCell component="td" scope="row">
                                    {row.nombre}
                                </TableCell>
                                <TableCell component="td" scope="row">
                                    <Button className={classes.icon} variant="contained" color="primary" onClick={() => handleDownload(row)}>
                                        <ArrowDownwardIcon />
                                    </Button>
                                </TableCell>
                                <TableCell component="td" scope="row">
                                    <Button className={classes.icon} variant="contained" color="primary" disabled={props.disabled} onClick={() => handleRemoveFile(row)}>
                                        <Delete />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


        </Container>

        {showLoading &&
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(CartaInstruccion);
